module.exports = __webpack_public_path__ + "img/creator_title.e1400781.png";